module.exports = __webpack_public_path__ + "img/qr-code.86e3e275.svg";